import { useEffect, useMemo } from 'react';
import type { DataState } from '@atlassian/jira-common-services/src/types.tsx';
import { createResource, useResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_SERVICEDESK_JSM_CONTEXT } from './constants.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-jsm-context", jiraSpaEntry: "async-resource-servicedesk-jsm-context" */ './controllers/get-data'
	);

const ONE_DAY_IN_MILLIS = 60 * 60 * 1000 * 24;

export type JsmContext = {
	opsgenieStatus: string;
};

export const servicedeskJsmContextResource = createResource<JsmContext>({
	type: RESOURCE_TYPE_SERVICEDESK_JSM_CONTEXT,
	getKey: () => 'state',
	getDataLoader,
	maxAge: ONE_DAY_IN_MILLIS,
});

export const useJsmContextWithLoadOnMount: () => DataState<JsmContext> = () => {
	const { data, loading, error, refresh } = useResource<JsmContext>(servicedeskJsmContextResource);
	useEffect(() => {
		if (!data && !loading && !error) {
			refresh();
		}
	}, [data, loading, error, refresh]);

	return useMemo(
		() => ({
			data,
			loading,
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			error: error as Error,
		}),
		[data, loading, error],
	);
};
